import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TwoFactorSettings from './components/TwoFactorSettings';
import FieldSet from 'flarum/common/components/FieldSet';
import LinkButton from 'flarum/common/components/LinkButton';
export default function extendUserSecurityPage() {
  extend('flarum/forum/components/UserSecurityPage', 'settingsItems', function (items) {
    items.add('twoFactor', m(FieldSet, {
      label: app.translator.trans('ianm-twofactor.forum.security.two_factor_heading')
    }, m("p", {
      className: "helpText"
    }, app.translator.trans('ianm-twofactor.forum.security.two_factor_help')), m("p", {
      className: "helpText"
    }, app.translator.trans('ianm-twofactor.forum.security.two_factor_apps', {
      google: m(LinkButton, {
        external: true,
        href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Google Authenticator"),
      microsoft: m(LinkButton, {
        external: true,
        href: "https://www.microsoft.com/en-us/account/authenticator",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Microsoft Authenticator"),
      authy: m(LinkButton, {
        external: true,
        href: "https://authy.com/download/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Authy")
    })), m(TwoFactorSettings, {
      user: this.user
    })), 100);
  });
}